import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { ActivatedRoute } from '@angular/router';
import { IHelpTopic, ISubTopic } from '../../../../../auth/models/IUser';
import { AuthService } from '../../../../../auth/services/auth.service';

@Component({
  selector: 'app-help-topics',
  templateUrl: './help-topics.component.html',
  styleUrl: './help-topics.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatExpansionModule,
    MatButtonModule,
  ],
})
export class HelpTopicsComponent implements OnInit {
  panelOpenState = false;
  videoPopup: boolean = false;
  selectedIndex: number = 0;
  helpTopicsList: IHelpTopic[] = [];
  subTopicsList: ISubTopic[] = [];
  videoFile: string = '';
  constructor(
    private readonly location: Location,
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.route.queryParams?.subscribe(({ tab }) => {
      const index = Number(tab);
      if (!isNaN(index) && index !== -1) {
        this.selectedIndex = index;
        this.helpTopics();
      }
    });
  }
  helpTopics() {
    this.authService.getHelpTopics()?.subscribe({
      next: response => {
        if (response) this.helpTopicsList = response;
      },
    });
  }
  closeHelpTopics() {
    this.location.back();
  }
  toggleVideoPopup(file?: string | null) {
    this.videoFile = file as string;
    this.videoPopup = !this.videoPopup;
  }
  selectTab(index: number) {
    this.selectedIndex = index;
  }

  nextTab() {
    if (this.selectedIndex < this.helpTopicsList.length - 1) {
      this.selectedIndex++;
    }
  }

  prevTab() {
    if (this.selectedIndex > 0) {
      this.selectedIndex--;
    }
  }
}
